/**
 * Comprehensive list of country codes with flags
 * Used across all forms in the application
 */

export const countryCodes = [
  { code: '+1', flag: '🇺🇸', name: 'United States', country: 'US' },
  { code: '+1', flag: '🇨🇦', name: 'Canada', country: 'CA' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom', country: 'GB' },
  { code: '+93', flag: '🇦🇫', name: 'Afghanistan', country: 'AF' },
  { code: '+355', flag: '🇦🇱', name: 'Albania', country: 'AL' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria', country: 'DZ' },
  { code: '+376', flag: '🇦🇩', name: 'Andorra', country: 'AD' },
  { code: '+244', flag: '🇦🇴', name: 'Angola', country: 'AO' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina', country: 'AR' },
  { code: '+374', flag: '🇦🇲', name: 'Armenia', country: 'AM' },
  { code: '+61', flag: '🇦🇺', name: 'Australia', country: 'AU' },
  { code: '+43', flag: '🇦🇹', name: 'Austria', country: 'AT' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan', country: 'AZ' },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain', country: 'BH' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh', country: 'BD' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus', country: 'BY' },
  { code: '+32', flag: '🇧🇪', name: 'Belgium', country: 'BE' },
  { code: '+501', flag: '🇧🇿', name: 'Belize', country: 'BZ' },
  { code: '+229', flag: '🇧🇯', name: 'Benin', country: 'BJ' },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan', country: 'BT' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia', country: 'BO' },
  { code: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina', country: 'BA' },
  { code: '+267', flag: '🇧🇼', name: 'Botswana', country: 'BW' },
  { code: '+55', flag: '🇧🇷', name: 'Brazil', country: 'BR' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei', country: 'BN' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria', country: 'BG' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso', country: 'BF' },
  { code: '+257', flag: '🇧🇮', name: 'Burundi', country: 'BI' },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia', country: 'KH' },
  { code: '+237', flag: '🇨🇲', name: 'Cameroon', country: 'CM' },
  { code: '+238', flag: '🇨🇻', name: 'Cape Verde', country: 'CV' },
  { code: '+236', flag: '🇨🇫', name: 'Central African Republic', country: 'CF' },
  { code: '+235', flag: '🇹🇩', name: 'Chad', country: 'TD' },
  { code: '+56', flag: '🇨🇱', name: 'Chile', country: 'CL' },
  { code: '+86', flag: '🇨🇳', name: 'China', country: 'CN' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia', country: 'CO' },
  { code: '+269', flag: '🇰🇲', name: 'Comoros', country: 'KM' },
  { code: '+242', flag: '🇨🇬', name: 'Congo', country: 'CG' },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica', country: 'CR' },
  { code: '+385', flag: '🇭🇷', name: 'Croatia', country: 'HR' },
  { code: '+53', flag: '🇨🇺', name: 'Cuba', country: 'CU' },
  { code: '+357', flag: '🇨🇾', name: 'Cyprus', country: 'CY' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic', country: 'CZ' },
  { code: '+45', flag: '🇩🇰', name: 'Denmark', country: 'DK' },
  { code: '+253', flag: '🇩🇯', name: 'Djibouti', country: 'DJ' },
  { code: '+593', flag: '🇪🇨', name: 'Ecuador', country: 'EC' },
  { code: '+20', flag: '🇪🇬', name: 'Egypt', country: 'EG' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador', country: 'SV' },
  { code: '+240', flag: '🇬🇶', name: 'Equatorial Guinea', country: 'GQ' },
  { code: '+291', flag: '🇪🇷', name: 'Eritrea', country: 'ER' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia', country: 'EE' },
  { code: '+251', flag: '🇪🇹', name: 'Ethiopia', country: 'ET' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji', country: 'FJ' },
  { code: '+358', flag: '🇫🇮', name: 'Finland', country: 'FI' },
  { code: '+33', flag: '🇫🇷', name: 'France', country: 'FR' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon', country: 'GA' },
  { code: '+220', flag: '🇬🇲', name: 'Gambia', country: 'GM' },
  { code: '+995', flag: '🇬🇪', name: 'Georgia', country: 'GE' },
  { code: '+49', flag: '🇩🇪', name: 'Germany', country: 'DE' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana', country: 'GH' },
  { code: '+30', flag: '🇬🇷', name: 'Greece', country: 'GR' },
  { code: '+299', flag: '🇬🇱', name: 'Greenland', country: 'GL' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala', country: 'GT' },
  { code: '+224', flag: '🇬🇳', name: 'Guinea', country: 'GN' },
  { code: '+245', flag: '🇬🇼', name: 'Guinea-Bissau', country: 'GW' },
  { code: '+592', flag: '🇬🇾', name: 'Guyana', country: 'GY' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti', country: 'HT' },
  { code: '+504', flag: '🇭🇳', name: 'Honduras', country: 'HN' },
  { code: '+852', flag: '🇭🇰', name: 'Hong Kong', country: 'HK' },
  { code: '+36', flag: '🇭🇺', name: 'Hungary', country: 'HU' },
  { code: '+354', flag: '🇮🇸', name: 'Iceland', country: 'IS' },
  { code: '+91', flag: '🇮🇳', name: 'India', country: 'IN' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia', country: 'ID' },
  { code: '+98', flag: '🇮🇷', name: 'Iran', country: 'IR' },
  { code: '+964', flag: '🇮🇶', name: 'Iraq', country: 'IQ' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland', country: 'IE' },
  { code: '+972', flag: '🇮🇱', name: 'Israel', country: 'IL' },
  { code: '+39', flag: '🇮🇹', name: 'Italy', country: 'IT' },
  { code: '+225', flag: '🇨🇮', name: 'Ivory Coast', country: 'CI' },
  { code: '+81', flag: '🇯🇵', name: 'Japan', country: 'JP' },
  { code: '+962', flag: '🇯🇴', name: 'Jordan', country: 'JO' },
  { code: '+7', flag: '🇰🇿', name: 'Kazakhstan', country: 'KZ' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya', country: 'KE' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait', country: 'KW' },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan', country: 'KG' },
  { code: '+856', flag: '🇱🇦', name: 'Laos', country: 'LA' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia', country: 'LV' },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon', country: 'LB' },
  { code: '+266', flag: '🇱🇸', name: 'Lesotho', country: 'LS' },
  { code: '+231', flag: '🇱🇷', name: 'Liberia', country: 'LR' },
  { code: '+218', flag: '🇱🇾', name: 'Libya', country: 'LY' },
  { code: '+423', flag: '🇱🇮', name: 'Liechtenstein', country: 'LI' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania', country: 'LT' },
  { code: '+352', flag: '🇱🇺', name: 'Luxembourg', country: 'LU' },
  { code: '+853', flag: '🇲🇴', name: 'Macau', country: 'MO' },
  { code: '+389', flag: '🇲🇰', name: 'Macedonia', country: 'MK' },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar', country: 'MG' },
  { code: '+265', flag: '🇲🇼', name: 'Malawi', country: 'MW' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia', country: 'MY' },
  { code: '+960', flag: '🇲🇻', name: 'Maldives', country: 'MV' },
  { code: '+223', flag: '🇲🇱', name: 'Mali', country: 'ML' },
  { code: '+356', flag: '🇲🇹', name: 'Malta', country: 'MT' },
  { code: '+222', flag: '🇲🇷', name: 'Mauritania', country: 'MR' },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius', country: 'MU' },
  { code: '+52', flag: '🇲🇽', name: 'Mexico', country: 'MX' },
  { code: '+373', flag: '🇲🇩', name: 'Moldova', country: 'MD' },
  { code: '+377', flag: '🇲🇨', name: 'Monaco', country: 'MC' },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia', country: 'MN' },
  { code: '+382', flag: '🇲🇪', name: 'Montenegro', country: 'ME' },
  { code: '+212', flag: '🇲🇦', name: 'Morocco', country: 'MA' },
  { code: '+258', flag: '🇲🇿', name: 'Mozambique', country: 'MZ' },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar', country: 'MM' },
  { code: '+264', flag: '🇳🇦', name: 'Namibia', country: 'NA' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal', country: 'NP' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands', country: 'NL' },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand', country: 'NZ' },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua', country: 'NI' },
  { code: '+227', flag: '🇳🇪', name: 'Niger', country: 'NE' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria', country: 'NG' },
  { code: '+850', flag: '🇰🇵', name: 'North Korea', country: 'KP' },
  { code: '+47', flag: '🇳🇴', name: 'Norway', country: 'NO' },
  { code: '+968', flag: '🇴🇲', name: 'Oman', country: 'OM' },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan', country: 'PK' },
  { code: '+970', flag: '🇵🇸', name: 'Palestine', country: 'PS' },
  { code: '+507', flag: '🇵🇦', name: 'Panama', country: 'PA' },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea', country: 'PG' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay', country: 'PY' },
  { code: '+51', flag: '🇵🇪', name: 'Peru', country: 'PE' },
  { code: '+63', flag: '🇵🇭', name: 'Philippines', country: 'PH' },
  { code: '+48', flag: '🇵🇱', name: 'Poland', country: 'PL' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal', country: 'PT' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar', country: 'QA' },
  { code: '+40', flag: '🇷🇴', name: 'Romania', country: 'RO' },
  { code: '+7', flag: '🇷🇺', name: 'Russia', country: 'RU' },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda', country: 'RW' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia', country: 'SA' },
  { code: '+221', flag: '🇸🇳', name: 'Senegal', country: 'SN' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia', country: 'RS' },
  { code: '+248', flag: '🇸🇨', name: 'Seychelles', country: 'SC' },
  { code: '+232', flag: '🇸🇱', name: 'Sierra Leone', country: 'SL' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore', country: 'SG' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia', country: 'SK' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia', country: 'SI' },
  { code: '+252', flag: '🇸🇴', name: 'Somalia', country: 'SO' },
  { code: '+27', flag: '🇿🇦', name: 'South Africa', country: 'ZA' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea', country: 'KR' },
  { code: '+211', flag: '🇸🇸', name: 'South Sudan', country: 'SS' },
  { code: '+34', flag: '🇪🇸', name: 'Spain', country: 'ES' },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka', country: 'LK' },
  { code: '+249', flag: '🇸🇩', name: 'Sudan', country: 'SD' },
  { code: '+597', flag: '🇸🇷', name: 'Suriname', country: 'SR' },
  { code: '+268', flag: '🇸🇿', name: 'Swaziland', country: 'SZ' },
  { code: '+46', flag: '🇸🇪', name: 'Sweden', country: 'SE' },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland', country: 'CH' },
  { code: '+963', flag: '🇸🇾', name: 'Syria', country: 'SY' },
  { code: '+886', flag: '🇹🇼', name: 'Taiwan', country: 'TW' },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan', country: 'TJ' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania', country: 'TZ' },
  { code: '+66', flag: '🇹🇭', name: 'Thailand', country: 'TH' },
  { code: '+228', flag: '🇹🇬', name: 'Togo', country: 'TG' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia', country: 'TN' },
  { code: '+90', flag: '🇹🇷', name: 'Turkey', country: 'TR' },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan', country: 'TM' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda', country: 'UG' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine', country: 'UA' },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates', country: 'AE' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay', country: 'UY' },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan', country: 'UZ' },
  { code: '+58', flag: '🇻🇪', name: 'Venezuela', country: 'VE' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam', country: 'VN' },
  { code: '+967', flag: '🇾🇪', name: 'Yemen', country: 'YE' },
  { code: '+260', flag: '🇿🇲', name: 'Zambia', country: 'ZM' },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabwe', country: 'ZW' }
];
